const upperCaseOptions = ['yes', 'no'];

function setContractName(el) {
  const text = el.textContent.trim();
  if (upperCaseOptions.includes(text.toLowerCase())) {
    el.textContent = text.toUpperCase();
  }
}

export default {
  bind(el) {
    setContractName(el);
  },
  update(el) {
    setContractName(el);
  },
};



// WEBPACK FOOTER //
// ./src/directives/contract-name.js